/****************************************************************************/
/* Women Circle: Sprache automatisch aus der Shop-Sprache setzen            */
/* Stand 08.09.2026                                                         */
/*                                                                          */
/* /pages/women-circle ist eine eigenstaendige Landingpage mit eigenem      */
/* EN/DE/JP-Umschalter. Sie richtet sich nach dem lang-Attribut der Seite,  */
/* das fest verdrahtet ist, und merkt sich die Wahl in localStorage unter   */
/* 'pwc_lang'. Ergebnis vorher: auf /de/ und /ja/ kam nicht die Shop-       */
/* Sprache heraus.                                                          */
/*                                                                          */
/* Sprache kommt jetzt aus dem URL-Praefix (/de/ oder /ja/). Damit eine     */
/* eigene Wahl des Besuchers erhalten bleibt, merken wir uns in             */
/* 'pwc_lang_auto', welchen Wert WIR gesetzt haben: stimmt der gespeicherte */
/* Wert damit ueberein, war es unsere Automatik und darf ueberschrieben     */
/* werden - weicht er ab, hat der Besucher selbst geklickt.                 */
/*                                                                          */
/* Steht bewusst GANZ OBEN: weiter unten laeuft der Typing-Effekt, der auf  */
/* Seiten ohne .typing-text eine Exception geworfen und damit alles         */
/* Nachfolgende in dieser Datei abgebrochen hat.                            */
/****************************************************************************/
(function () {
  var path = window.location.pathname;
  if (path.indexOf('/pages/women-circle') === -1) return;

  var m = path.match(/^\/([a-z]{2})(?:-[a-zA-Z]{2})?\//);
  var code = m ? m[1] : String((window.Shopify && window.Shopify.locale) || 'en').slice(0, 2).toLowerCase();

  var target = 'en';
  if (code === 'de') target = 'de';
  else if (code === 'ja' || code === 'jp') target = 'jp';

  var auto = null;
  try { auto = window.localStorage.getItem('pwc_lang_auto'); } catch (e) { return; }

  var tries = 0;
  var done = false;

  function enforce() {
    tries++;
    var active = document.querySelector('[data-lang].active');

    if (active && typeof window.setLang === 'function') {
      var current = active.getAttribute('data-lang');
      var stored = null;
      try { stored = window.localStorage.getItem('pwc_lang'); } catch (e) {}

      if (auto !== null && stored !== null && stored !== auto) { done = true; return; }

      if (current !== target) { window.setLang(target); }
      try { window.localStorage.setItem('pwc_lang_auto', target); } catch (e) {}
      if (tries > 8) { done = true; return; }
    }

    if (!done && tries < 30) setTimeout(enforce, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();


function scrollToTarget() {
    var targetDiv = document.getElementById('scroll-section-landingpage');
    if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'auto' }); // Disable smooth scrolling temporarily
        setTimeout(function () {
            targetDiv.scrollIntoView({ behavior: 'smooth' }); // Enable smooth scrolling after a short delay
        }, 1);
    }
}

/**************************/
/* Hero Images 2 girls Effect */
/**************************/

function isHeroImageInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const topRelativeToViewport = (rect.top + rect.height / 2) / windowHeight;

  return topRelativeToViewport >= 0.35 && topRelativeToViewport <= 0.65;
}

function setHeroImageBorderRadius(image) {
  image.style.transition = 'border-radius 1s';

  if (isHeroImageInViewport(image)) {
    image.style.borderRadius = '0%';
  } else {
    image.style.borderRadius = '50% 0';
  }
}

function updateHeroImageBorderRadius() {
  const image = document.querySelector('.profiles-container img');

  if (image) {
    setHeroImageBorderRadius(image);
  }
}

window.addEventListener('scroll', updateHeroImageBorderRadius);
updateHeroImageBorderRadius();


/**************************/
/* Typing Text HERO Effect */
/**************************/

const dynamicText = document.querySelector(".typing-text h1 span");
const words = ["Colorful Pancake Baking Mixes!", "Flavored Chocolate Pretzels!", "Healthy Mueslis!", "Bread Baking Mixes!",  "Exciting Spices!"];
// Variables to track the position and deletion status of the word
let wordIndex = 0;
let charIndex = 0;
let isDeleting = false;
const typeEffect = () => {
    if (!dynamicText) return; // Schutz: auf Seiten ohne Typing-Element sonst Exception (08.09.2026)
    const currentWord = words[wordIndex];
    const currentChar = currentWord.substring(0, charIndex);
    dynamicText.textContent = currentChar;
    dynamicText.classList.add("stop-blinking");
    if (!isDeleting && charIndex < currentWord.length) {
        // If condition is true, type the next character
        charIndex++;
        setTimeout(typeEffect, 100);
    } else if (isDeleting && charIndex > 0) {
        // If condition is true, remove the previous character
        charIndex--;
        setTimeout(typeEffect, 50);
    } else {
        // If word is deleted then switch to the next word
        isDeleting = !isDeleting;
        dynamicText.classList.remove("stop-blinking");
        wordIndex = !isDeleting ? (wordIndex + 1) % words.length : wordIndex;
        setTimeout(typeEffect, 1200);
    }
}
typeEffect();
